
export default {
  selectCourseList: { // 과정목록 조회
    method: 'GET',
    url: 'mrm/v1/permit/nrw/course/courseList'
  },
  courseDetailV2: {
    method: 'POST',
    url: 'mrm/v1/permit/nrw/course/Detail'
  },
  eplogMoreV2: {
    method: 'POST',
    url: 'mrm/v1/permit/nrw/course/eplogMore'
  },
  courseInfoV2: {
    method: 'POST',
    url: 'mrm/v1/permit/nrw/courseInfo'
  },
  telApplicationV2: {
    method: 'POST',
    url: 'mrm/v1/permit/nrw/telApplication'
  }
}



// WEBPACK FOOTER //
// ./src/config/router/nrw/api/courseApi.js